/* tslint:disable */
import { ViewStudyEquipment } from './view-study-equipment';

/**
 */
export class ViewProgressBar {
    studyEquipments?: ViewStudyEquipment[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-progress-bar.ts